import classNames from "classnames";
import { CardFrame } from "./CardFrame";
import { CardOrientation } from "~/models/card";

export const ViewCard = ({
  imageComponent,
  largeImageSize = false,
  title,
  description,
  orientation = "vertical",
}: {
  imageComponent: React.ReactNode;
  largeImageSize?: boolean;
  title: string;
  description: string;
  orientation?: CardOrientation;
}) => {
  return (
    <CardFrame
      image={imageComponent}
      className={classNames(
        orientation === "horizontal"
          ? "tw:h-full"
          : "tw:min-w-[250px] tw:max-w-[700px] tw:h-full",
      )}
      orientation={orientation}
      largeImageSize={largeImageSize}
    >
      <div
        className={classNames(
          "tw:flex tw:flex-col tw:gap-4 tw:px-6 tw:py-4 tw:min-h-[200px]",
          orientation === "horizontal" && largeImageSize
            ? "tw:justify-center tw:h-full"
            : "",
        )}
      >
        <div
          className={classNames(
            "tw:tracking-tight tw:font-[600]",
            orientation === "horizontal" && largeImageSize
              ? "tw:text-[2rem]"
              : "tw:text-xl",
          )}
        >
          {title ?? ""}
        </div>
        <div
          className="tw:font-[400] tw:text-base tw:leading-normal"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    </CardFrame>
  );
};
